import { connect } from 'react-redux';
import React, { PropTypes } from 'react';
import { fetchSites } from '../actions/sites';
import { getSites } from '../reducers/sites';
import Site from './Site';
import { fetchForm, updateData } from '../actions/form';
import { fetchRequirements } from '../actions/requirements';
import { getSiteInfos } from '../reducers/form';
import {
  getSecurityEpis,
  getWorkers,
  getInventoryToPlan,
} from '../reducers/requirements';
import { Accordion } from 'semantic-ui-react';
import { isFetching } from '../reducers';

export class Page extends React.Component {
  constructor(props) {
    super(props);
    this.state = { activeIndex: 0 };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e, titleProps) {
    const { index } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;

    this.setState({ activeIndex: newIndex });
  }

  componentWillMount() {
    this.props.fetchRequirements(this.props.id);
    this.props.fetchSites(this.props.id);
    this.props.fetchForm(this.props.id);
  }

  render() {
    const valueChanged = siteId => (propName, propValue) => {
      this.props.updateData(siteId, propName, propValue);
    };

    const { activeIndex } = this.state;

    const segments = sites =>
      sites.map((s, index) => (
        <Site
          key={s.id}
          index={index}
          currentIndex={activeIndex}
          handleClick={this.handleClick}
          site={s}
          onChange={valueChanged(s.id)}
          siteInfos={this.props.getInfos(s.id)}
          workers={this.props.workers}
          securityEpis={this.props.securityEpis}
          inventoryToPlan={this.props.inventoryToPlan}
        />
      ));

    if (!this.props.isFetching) {
      return (
        <Accordion styled fluid>
          {this.props.sites && segments(this.props.sites)}
        </Accordion>
      );
    } else {
      return (
        <div
          className="ui active loading segment"
          style={{ minHeight: '180px' }}
        />
      );
    }
  }
}

Page.propTypes = {
  id: PropTypes.number.isRequired,
  customerId: PropTypes.number.isRequired,
  fetchSites: PropTypes.func.isRequired,
  sites: PropTypes.array.isRequired,
  fetchForm: PropTypes.func.isRequired,
  fetchRequirements: PropTypes.func.isRequired,
  getInfos: PropTypes.func.isRequired,
  workers: PropTypes.array.isRequired,
  securityEpis: PropTypes.array.isRequired,
  inventoryToPlan: PropTypes.array.isRequired,
  isFetching: PropTypes.bool.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  sites: getSites(state),
  getInfos: getSiteInfos(state),
  workers: getWorkers(state),
  securityEpis: getSecurityEpis(state),
  inventoryToPlan: getInventoryToPlan(state),
  isFetching: isFetching(state),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchSites: caseId => dispatch(fetchSites(caseId)),
  fetchRequirements: caseId => dispatch(fetchRequirements(caseId)),
  fetchForm: caseId => dispatch(fetchForm(caseId)),
  updateData: (siteId, propName, propValue) =>
    dispatch(updateData(siteId, propName, propValue)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Page);



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases-creation/step3/components/Page.js